// extracted by mini-css-extract-plugin
module.exports = {"footerContent":"FooterChat_footerContent__2RAni","link":"FooterChat_link__fJ-y2","subtext":"FooterChat_subtext__1vR3S"};